import getTranslateParams from "./getTranslateParams";
export default (rangeSelectorRef) => {
    var _a;
    const element = (_a = rangeSelectorRef.current) === null || _a === void 0 ? void 0 : _a.instance.element();
    const firstSlider = element === null || element === void 0 ? void 0 : element.querySelector(".dxrs-slidersContainer .slider:not(:last-child)");
    const lastSlider = element === null || element === void 0 ? void 0 : element.querySelector(".dxrs-slidersContainer .slider:last-child");
    if (!firstSlider || !lastSlider)
        return { leftSlider: undefined, rightSlider: undefined };
    const { x: firstX } = getTranslateParams(firstSlider);
    const { x: lastX } = getTranslateParams(lastSlider);
    return {
        leftSlider: firstX > lastX ? lastSlider : firstSlider,
        rightSlider: firstX > lastX ? firstSlider : lastSlider
    };
};
